// extracted by mini-css-extract-plugin
export default {"card":"M5-z"};